<template>
  <div id="organisation-tab-bar">
    <swiper class="organisation-menu-swiper" :options="swiperOption" v-dragscroll.x>

        <swiper-slide class="organisation-menu-menu-box">

          <router-link :to="{ name: 'overview' }" class="organisation-menu-wrapper" exact>
            <p>{{ $t("organisation.overview.title")}}</p>
          </router-link>

          <router-link :to="{ name: 'events' }" class="organisation-menu-wrapper">
            <p>{{ $t("organisation.event.title")}}</p>
          </router-link>

          <!-- <router-link :to="{ name: 'attendees' }" class="organisation-menu-wrapper">
            <p>Attendees</p>
          </router-link> -->

          <router-link :to="{ name: 'team' }" class="organisation-menu-wrapper">
            <p>{{ $t("organisation.team.title")}}</p>
          </router-link>

          <router-link :to="{ name: 'profile' }" class="organisation-menu-wrapper">
            <p>{{ $t("organisation.profile.title")}}</p>
          </router-link>

          <router-link :to="{ name: 'integrations' }" class="organisation-menu-wrapper">
            <p>{{ $t("organisation.integration.title")}}</p>
          </router-link>

          <router-link :to="{ name: 'billing' }" class="organisation-menu-wrapper">
            <p>{{ $t("organisation.billing.title")}}</p>
          </router-link>

          <!-- <router-link :to="{ name: 'settings' }" class="organisation-menu-wrapper">
            <p>Settings</p>
          </router-link> -->

        </swiper-slide>

    </swiper>
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll';

export default {
  name: "OrganisationTabBar",
  directives: {
    dragscroll,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",  
      }
    };
  },
  computed: { },
  mounted() { },
  watch: { },
  methods: { },
};
</script>

<style lang="less">
#organisation-tab-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .organisation-menu-swiper {
    width: calc(~"100% - 30px");
    margin: 12px 0px;
    border-bottom: 1px solid #F1F3F6;

    .organisation-menu-menu-box {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .organisation-menu-wrapper {
        margin: 16px 18px;

        &.active {
          position: relative;

          p {
            color: #292F3B !important;
            font-weight: 600;
          }

          &:before {
            content: '';
            width: calc(~"100% + 20px");
            height: 2px;
            background-color: #03658C;
            display: block;
            margin-top: 26px;
            margin-left: -10px;
            position: absolute;
          }
        }

        p {
          color: #8C929C;
          font-size: 16px;
          font-weight: 600;
          margin: 0px;
          padding: 0px;
          line-height: 14px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/OrganisationTabBar.vue